import { ReactNode } from 'react';
// form
import { FormProvider as Form, UseFormReturn } from 'react-hook-form';

type Props = {
  children: ReactNode;
  methods: UseFormReturn<any>;
  onSubmit?: VoidFunction;
  sx?: Object;
};

export default function FormProvider({
  children,
  onSubmit,
  methods,
  sx,
}: Props) {
  return (
    <Form {...methods}>
      <form onSubmit={onSubmit} style={sx}>
        {children}
      </form>
    </Form>
  );
}
